import React, { useState, useEffect } from 'react';
import { IconButton, Badge, Menu, MenuItem } from '@mui/material';
import { useRestApi } from 'context/RestApiContext';
import './ClientCard.css';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { HISTORY_TYPE } from 'constants/constants';

// 新着アイコンボタン
const NewNotificationButtonIcon = (props) => {
  const restApi = useRestApi();

  const [notices, setNotices] = useState([]);
  const [publicLimits, setPublicLimits] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [newFlg, setNewFlg] = useState(props.newFlg);

  // メニューを開く処理
  const handleClick = (event) => {
    const currentTarget = event.currentTarget;
    restApi.get('/api/cards/notices', (data) => {
      setNotices(data.notices);
      setPublicLimits(data.public_limits || []);
      setNewFlg(data.notices.some((x) => x.NEW_FLG == 1) || (data.public_limits || []).length > 0);
      setAnchorEl(currentTarget);
    });
  };

  useEffect(() => {
    setNewFlg(props.newFlg);
  }, [props.newFlg]);

  // メニューを閉じる処理
  const handleClose = () => {
    setAnchorEl(null);
  };

  // メニューを選択
  const handleOnClickMenuItem = (card) => {
    props.callEditModal(card);
    setAnchorEl(null);
  };

  // 新着を上に、確認済みを下にソート
  const sortedNotices = [...notices].sort((a, b) => b.NEW_FLG - a.NEW_FLG);
  // 新着の中で最後のインデックスを取得（公開期限間近の挿入位置）
  const lastNewIndex = sortedNotices.filter((x) => x.NEW_FLG == 1).length;

  return (
    <>
      <IconButton onClick={handleClick}>
        <Badge color="error" variant="dot" invisible={!newFlg}>
          <NotificationsNoneOutlinedIcon style={{ fontSize: 26 }} />
        </Badge>
      </IconButton>
      {/* メニューの定義 */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {/* 新着通知（NEW_FLG=1）*/}
        {sortedNotices.slice(0, lastNewIndex).map((x, i) => (
          <MenuItem key={`notice-${i}`} onClick={() => handleOnClickMenuItem(x)} className="p-1">
            <div className="newcomments">
              <span className="new-dot" aria-label="new" />
              {x.TITLE}
              <span>
                <div style={{ fontSize: '8pt' }}>
                  <b>{x.TAN_NAME}</b>さん
                  {x.HISTORY_TYPE === HISTORY_TYPE.ADD_COMMENT
                    ? 'がコメントしました'
                    : x.HISTORY_TYPE === HISTORY_TYPE.CHECKED_ITEM
                      ? 'がチェック項目を完了しました'
                      : ''}
                  <span style={{ fontSize: '10pt' }} className="pl-2">
                    &nbsp;{x.INS_DATE}&nbsp;{x.INS_TIME}
                  </span>
                </div>
                <div className="newcomments-item">{x.HISTORY_CONTENT}</div>
              </span>
            </div>
          </MenuItem>
        ))}
        {/* 公開期限間近 */}
        {publicLimits.map((x, i) => (
          <MenuItem key={`limit-${i}`} onClick={() => handleOnClickMenuItem(x)} className="p-1">
            <div className="newcomments">
              <span className="new-dot" aria-label="new" />
              {x.TITLE}
              <span>
                <div style={{ fontSize: '8pt' }}>公開期限: {x.SHARED_EXPIRE}</div>
                <div className="mt-1 shared-public-limit-icon">
                  <WarningAmberIcon style={{ fontSize: 'small' }} />
                  共有ページが公開期限間近です！
                </div>
              </span>
            </div>
          </MenuItem>
        ))}
        {/* 確認済み通知（NEW_FLG=0）*/}
        {sortedNotices.slice(lastNewIndex).map((x, i) => (
          <MenuItem key={`old-${i}`} onClick={() => handleOnClickMenuItem(x)} className="p-1">
            <div className="newcomments">
              {x.TITLE}
              <span>
                <div style={{ fontSize: '8pt' }}>
                  <b>{x.TAN_NAME}</b>さん
                  {x.HISTORY_TYPE === HISTORY_TYPE.ADD_COMMENT
                    ? 'がコメントしました'
                    : x.HISTORY_TYPE === HISTORY_TYPE.CHECKED_ITEM
                      ? 'がチェック項目を完了しました'
                      : ''}
                  <span style={{ fontSize: '10pt' }} className="pl-2">
                    &nbsp;{x.INS_DATE}&nbsp;{x.INS_TIME}
                  </span>
                </div>
                <div className="newcomments-item">{x.HISTORY_CONTENT}</div>
              </span>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default NewNotificationButtonIcon;
